import { reducerWithInitialState } from "typescript-fsa-reducers"
import { uuidActions } from "../actions/UUIDAction"

export interface UUIDState {
  uuid: string
}

const initialState: UUIDState = {
  uuid: ""
}
// Reduxを利用した画面間共通のUUIDstate初期化処理
export const uuidReducer = reducerWithInitialState(initialState)
  .case(uuidActions.updateUUID, (state, uuid) => {
    return { ...state, uuid }
  })
  .default((state) => {
    return state
  })
